import { Link } from 'react-router-dom';
import ListErrors from './ListErrors';
import React from 'react';
import agent from '../agent';
import { store } from '../store'
import { push } from 'react-router-redux'
import { connect } from 'react-redux';
import {
    SIGNATURE_PAGE_LOADED,
    GENERATE_SIGNATURE,
    SIGNATURE_PAGE_UNLOADED
} from '../constants/actionTypes';

const mapStateToProps = state => ({ ...state.common });

const mapDispatchToProps = dispatch => ({
    onLoad: () => {
        dispatch({ type: SIGNATURE_PAGE_LOADED })
    },
    onSubmit: (payload) => {
        dispatch({ type: GENERATE_SIGNATURE, payload })
    },
    onUnload: () =>
        dispatch({ type: SIGNATURE_PAGE_UNLOADED })
});

class Signature extends React.Component {
    constructor() {
        super();
        this.state = {
            sender: '',
            recipient: '',
            amount: '',
            symbol: '',
            nonce: '',
            privatekey: '',
            signature: ''
        }
        this.updateState = field => ev => {
            const state = this.state;
            const newState = Object.assign({}, state, { [field]: ev.target.value });
            this.setState(newState);
        };
        this.submitForm = (sender, recipient, amount, symbol, nonce, privatekey) => ev => {
            ev.preventDefault();
            const payload = agent.Common.generateSignature(sender, recipient, amount, symbol, nonce, privatekey)
            this.props.onSubmit(payload);
        }
    }
    componentWillMount() {
        if (this.props.currentUser) {
            Object.assign(this.state, {
                sender: '',
                recipient: '',
                amount: '',
                symbol: '',
                nonce: '',
                privatekey: '',
                signature: ''
            })
        } else {
            store.dispatch(push('/'))
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.signature) {
            this.setState({ signature: nextProps.signature })
        }
    }
    componentWillUnmount() {
        this.props.onUnload();
    }

    render() {
        const sender = this.state.sender;
        const recipient = this.state.recipient;
        const amount = this.state.amount;
        const symbol = this.state.symbol;
        const nonce = this.state.nonce;
        const privatekey = this.state.privatekey;
        const signature = this.state.signature

        return (
            <div class='pane'>
                <h1>Generate Signature</h1>
                <ListErrors errors={this.props.errors} />
                <form onSubmit={this.submitForm(sender, recipient, amount, symbol, nonce, privatekey)}>
                    <fieldset className="form">
                        <strong>sender</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="sender"
                                value={sender}
                                onChange={this.updateState('sender')} />
                        </fieldset>
                        <strong>recipient</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="recipient"
                                value={recipient}
                                onChange={this.updateState('recipient')} />
                        </fieldset>
                        <strong>amount</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="amount"
                                value={amount}
                                onChange={this.updateState('amount')} />
                        </fieldset>
                        <strong>symbol</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="symbol"
                                value={symbol}
                                onChange={this.updateState('symbol')} />
                        </fieldset>
                        <strong>nonce</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="nonce"
                                value={nonce}
                                onChange={this.updateState('nonce')} />
                        </fieldset>
                        <strong>private key</strong>
                        <fieldset className="form-group">
                            <input
                                type="text"
                                placeholder="private key"
                                value={privatekey}
                                onChange={this.updateState('privatekey')} />
                        </fieldset>
                        <fieldset className="form-group">
                            <button
                                type="submit"
                                disabled={this.props.inProgress}>
                                Generate Signature
                            </button>
                        </fieldset>
                        <hr />
                        <h1>Signature</h1>
                        {signature}
                    </fieldset>
                </form>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Signature);



// WEBPACK FOOTER //
// ./src/components/Signature.js